// initial state
const state = () => ({
    techInfo: {
        currentStep: 1,
        step1: {},
        step2: {},
        step3: {
            client: {
                name: '',
                phone: '',
                additionalInfo: '',
            },
            vehicleData: {
                plate: '',
                kilometers: ''
            }
        },
        maintenancePlanHtml: {
            id: 0,
            show: false,
            callRmi: false,
            rmiIdentifier: ''
        },
        maintenancePlanOptions: {
            operations: {
                maintenance: [],
                repair: []
            },
            parts: [],
            parametersForCalculations: {
                operations: [],
                parts: {},
                partsDiscountTotal: 0
            },
            numberOfChanges: 0,
            needToCheckItemMpId: null
        },
        crossReferences: []
    },
    techInfoSearchParam: '',
    watchTechInfoFromRoute: false
})

// getters
const getters = {
    getTechInfoState(state) {
        return state;
    },
    getTechInfoCurrentMaintenancePlanOptions(state) {
        return state.techInfo.maintenancePlanOptions;
    },
    getTechInfoStep1(state) {
        return state.techInfo.step1;
    },
    getTechInfoCurrentStep(state) {
        return state.techInfo.currentStep;
    },
    getTechInfoCrossReference(state) {
        return itemMpId => state.techInfo.crossReferences.find(o => o.itemMpId == itemMpId)
    },
    getTechInfoSearchParam(state) {
      return state.techInfoSearchParam;
    },
    getWatchTechInfoFromRoute(state) {
      return state.watchTechInfoFromRoute;
    }
}

// actions
const actions = {
    updateLocalStorage(state) {
      localStorage.setItem('techInfoB2b', JSON.stringify(state.getters.getTechInfoState));
    },
}

// mutations
const mutations = {
    setTechInfoState(state, payload) {
        for (var [key, value] of Object.entries(payload)) {
            state[key] = value;
        }
    },
    setTechInfo(state, payload) {
        for (var [key, value] of Object.entries(payload)) {
            state.techInfo[key] = value;
        }
        state.techInfo.maintenancePlanOptions.numberOfChanges++;
        this.dispatch('techInfo/updateLocalStorage');
    },
    setTechInfoCurrentStep(state, step) {
        state.techInfo.currentStep = step;
        this.dispatch('techInfo/updateLocalStorage');
    },
    setTechInfoClearMaintenancePlanOptionsToStep2(state) {
        state.techInfo.maintenancePlanOptions.operations.maintenance = [];
        state.techInfo.maintenancePlanOptions.operations.repair = [];
    },
    setTechInfoRemoveOrAddMaintenancePlanOptionsItem(state, payload) {
        let addItem = true;
        let isDuplicate = false;
        let newArray = [];

        state.techInfo.maintenancePlanOptions.operations[payload.type].filter((item, index) => {
            if (item.workId !== payload.item.workId) {
                newArray.push(item);
            } else {
                addItem = false;
            }
        });

        if (addItem) {
            // verifica se não tem duplicidade ao add novo item no carrinho
            state.techInfo.maintenancePlanOptions.operations[payload.type].filter((item, index) => {
                if (item.workId !== payload.item.workId && item.itemMpId === payload.item.itemMpId) {
                    isDuplicate = true;
                }
            });

            newArray.push(payload.item);
        }

        /**
         * Tratamento para a seguinte verificação de duplicidade:
         *
         * 1) caso acha duplicidade não altera o stado do carrinho,
         *    atualiza a variavel que está ocorrendo watch para reagir no modal
         *
         * 2) caso contrario altera o estado do carrinho
         */
        if (isDuplicate) {
            state.techInfo.maintenancePlanOptions.needToCheckItemMpId = payload;
        } else {
            state.techInfo.maintenancePlanOptions.operations[payload.type] = newArray;
            state.techInfo.maintenancePlanOptions.numberOfChanges++;
        }

        this.dispatch('techInfo/updateLocalStorage');
    },
    setTechInfoMaintenancePlanOptions(state, payload) {
        for (var [key, value] of Object.entries(payload)) {
            state.techInfo.maintenancePlanOptions.operations[key] = value;
        }

        state.techInfo.maintenancePlanOptions.numberOfChanges++;
        this.dispatch('techInfo/updateLocalStorage');
    },
    setTechInfoClearMaintenancePlanOptions(state) {
        state.techInfo.maintenancePlanOptions = {
            operations: {
                maintenance: [],
                repair: []
            },
            parts: [],
            parametersForCalculations: {
                operations: [],
                parts: {},
                partsDiscountTotal: 0
            },
            numberOfChanges: 0,
            needToCheckItemMpId: null
        };

        state.techInfo.step1 = {};
        state.techInfo.step2 = {};
        state.techInfo.step3 = {};

        state.techInfo.currentStep = 1;

        state.techInfo.maintenancePlanOptions.numberOfChanges++;

        localStorage.removeItem('techInfoB2b');
    },
    setTechInfoStep3(state, payload) {
      state.techInfo.step3 = payload;
    },
    setTechInfoCrossReference(state, payload) {
      state.techInfo.crossReferences.push(payload);
    },
    setTechInfoSearchParam(state, payload) {
      state.techInfoSearchParam = payload;
    },
    setWatchTechInfoFromRoute(state, payload) {
      state.watchTechInfoFromRoute = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
